/* eslint-disable react-hooks/exhaustive-deps */
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

import { menu } from "@/app/menu";
// import { DEFAULT_ROUTE } from "@/lib/static";
import { Link, useLocation } from "react-router-dom";
import { useMemo } from "react";
import { getUserInfo } from "@/lib/token";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export const DashboardBreadcrumb = () => {
  const location = useLocation();

  const navigate = useNavigate();

  const { company_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);

  const currentPath = location.pathname;
  const currentBreadcrumb = useMemo(() => {
    const isSubPage = location.pathname
      .split("/")
      .find((item) => item === "details" || item === "stats");
    return menu.navMain.find((item) =>
      isSubPage ? currentPath.startsWith(item.url) : currentPath === item.url
    );
  }, [currentPath]);

  // const [isParentList, setIsParentList] = useState(false);

  const isDetails = useMemo(() => {
    const allBreadcrumb = currentPath.split("/");
    return allBreadcrumb.find((item) => item === "details") ? true : false;
  }, [currentBreadcrumb, currentPath]);

  const isStats = useMemo(() => {
    return currentPath.split("/").includes("stats");
  }, [currentPath]);

  // const isParentList = parent && currentPath === "/document" ? true : false;
  const isParentDetails = useMemo(() => {
    const isParentExist = sessionStorage.getItem("parent");
    return isParentExist && isDetails ? true : false;
  }, [currentPath, isDetails]);

  const [searchParams, setSearchParams] = useSearchParams();
  const isParentList = searchParams.get("parent");

  return (
    <Breadcrumb className="-mb-2">
      <BreadcrumbList>
        <BreadcrumbItem className="">
          <BreadcrumbLink asChild>
            <Link to={"/dashboard"} className="capitalize">
              {company_id}
            </Link>
          </BreadcrumbLink>
        </BreadcrumbItem>

        {isStats ? (
          <>
            <BreadcrumbSeparator className="" />
            <BreadcrumbLink asChild>
              <Link to={currentBreadcrumb?.url || ""}>
                {currentBreadcrumb?.title}
              </Link>
            </BreadcrumbLink>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem>
              <BreadcrumbPage>Email Stats</BreadcrumbPage>
            </BreadcrumbItem>
          </>
        ) : isParentList ? (
          <>
            <BreadcrumbSeparator className="" />
            <BreadcrumbItem
              onClick={() => {
                setSearchParams({});
              }}
            >
              <BreadcrumbPage className="cursor-pointer opacity-60 hover:opacity-100 capitalize">
                {currentBreadcrumb?.title}
              </BreadcrumbPage>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="" />
            <BreadcrumbItem>
              <BreadcrumbPage>Child Document</BreadcrumbPage>
            </BreadcrumbItem>
          </>
        ) : isParentDetails ? (
          <>
            <BreadcrumbSeparator className="" />
            <BreadcrumbItem
              onClick={() => {
                setSearchParams({});
                sessionStorage.removeItem("parent");
                navigate("/document");
              }}
            >
              <BreadcrumbPage className="cursor-pointer opacity-60 hover:opacity-100 capitalize">
                {currentBreadcrumb?.title}
              </BreadcrumbPage>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="" />
            <BreadcrumbLink asChild>
              <Link to={currentBreadcrumb?.url || ""}>Child Document</Link>
            </BreadcrumbLink>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem>
              <BreadcrumbPage>Details</BreadcrumbPage>
            </BreadcrumbItem>
          </>
        ) : isDetails ? (
          <>
            <BreadcrumbSeparator className="" />
            <BreadcrumbLink asChild>
              <Link to={currentBreadcrumb?.url || ""}>
                {currentBreadcrumb?.title}
              </Link>
            </BreadcrumbLink>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem>
              <BreadcrumbPage>Details</BreadcrumbPage>
            </BreadcrumbItem>
          </>
        ) : (
          <>
            <BreadcrumbSeparator className="" />
            <BreadcrumbPage className="cursor-pointer opacity-60 hover:opacity-100 capitalize">
              {currentBreadcrumb?.title}
            </BreadcrumbPage>
          </>
        )}

        {/* <ConditionRenderer condition={isDetails && !isParentDetails}>
          <>
            <BreadcrumbSeparator className="" />
            <BreadcrumbLink asChild>
              <Link to={currentBreadcrumb?.url || ""}>
                {currentBreadcrumb?.title}
              </Link>
            </BreadcrumbLink>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem>
              <BreadcrumbPage>Details</BreadcrumbPage>
            </BreadcrumbItem>
          </>
          <ConditionRenderer
            condition={currentPath === "/dashboard" || isParentList}
          >
            <></>
            <>
              {isParentDetails ? null : (
                <>
                  <BreadcrumbSeparator className="" />
                  <BreadcrumbItem>
                    <BreadcrumbPage>{currentBreadcrumb?.title}</BreadcrumbPage>
                  </BreadcrumbItem>
                </>
              )}
            </>
          </ConditionRenderer>
        </ConditionRenderer>
        <ConditionRenderer condition={isParentDetails}>
          <>
            <BreadcrumbSeparator className="" />
            <BreadcrumbItem
              onClick={() => {
                setSearchParams({});
                setParent(undefined);
                localStorage.removeItem("parent");
                navigate("/document");
              }}
            >
              <BreadcrumbPage className="cursor-pointer opacity-60 hover:opacity-100 capitalize">
                {currentBreadcrumb?.title}
              </BreadcrumbPage>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="" />
            <BreadcrumbLink asChild>
              <Link to={currentBreadcrumb?.url || ""}>Child Document</Link>
            </BreadcrumbLink>
            <BreadcrumbSeparator className="hidden md:block" />
            <BreadcrumbItem>
              <BreadcrumbPage>Details</BreadcrumbPage>
            </BreadcrumbItem>
          </>
          <></>
        </ConditionRenderer>
        <ConditionRenderer condition={isParentList && !isParentDetails}>
          <>
            <BreadcrumbSeparator className="" />
            <BreadcrumbItem
              onClick={() => {
                setSearchParams({});
                setParent(undefined);
              }}
            >
              <BreadcrumbPage className="cursor-pointer opacity-60 hover:opacity-100 capitalize">
                {currentBreadcrumb?.title}
              </BreadcrumbPage>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="" />
            <BreadcrumbItem>
              <BreadcrumbPage>Child Document</BreadcrumbPage>
            </BreadcrumbItem>
          </>
          <></>
        </ConditionRenderer> */}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
